import { cva, type VariantProps } from 'class-variance-authority';

import type { JSX } from 'react';

import { cn } from '~/utils';
import { Dot } from '~/components/dot';
import { Text } from '~/components/text';
import { HStack } from '~/components/stack';

const statusTagVariants = cva(cn('items-center px-2.5 py-[5.5px] rounded-md'), {
  variants: {
    variant: {
      success: 'bg-illicitGreen-500/10',
      destructive: 'bg-desire-500/10',
    },
  },
  defaultVariants: {
    variant: 'success',
  },
});

interface IStatusTagProps extends VariantProps<typeof statusTagVariants> {
  text: string;
  className?: string;
}

export function StatusTag({
  text,
  variant,
  className,
}: IStatusTagProps): JSX.Element {
  return (
    <HStack
      className={cn(
        statusTagVariants({
          variant,
        }),
        className,
      )}
    >
      <Dot className='size-3.5' variant={variant} />
      <Text className='font-medium'>{text}</Text>
    </HStack>
  );
}
